/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react';
import { Icon, Stars, StripePlaceholder, Intensity, ColorSwatches, ProductCard } from './Primitives';

const CATEGORY_IMAGES = {
  beans: '/images/site/coffee-beans.png',
  pods: '/images/site/coffee-pods.png',
  machines: '/images/site/machines.png',
  gear: '/images/site/brewing-gear.png',
  drinkware: '/images/site/drinkware.png',
};

// Base pod prices in the catalog are for a 10-pack. Selecting 30 or 50
// scales the price accordingly, with a standard bulk discount per unit
// (10% off at 30, 15% off at 50) rather than a flat multiple.
const PACK_MULTIPLIER = { 10: 1, 30: 2.7, 50: 4.25 };

// Same idea for coffee bags. Base catalog price is for 250g, with a bulk
// discount at larger sizes. Grind is priced as a flat grinding-service
// surcharge rather than a multiplier, since it doesn't scale with weight
// the way size does.
const SIZE_MULTIPLIER = { '250g': 1, '500g': 1.8, '1kg': 3.2 };
const GRIND_SURCHARGE = { 'Whole Bean': 0, 'Espresso': 1, 'Filter': 1, 'French Press': 1 };

// =================== HOME ===================
export const HomePage = ({ data, onNav, onOpen, addToCart, wishlist, toggleWish, onOpenQuiz }) => {
  const featured = data.products.filter(p => ['b01', 'b02', 'b06', 'm01'].includes(p.id));
  return (
    <div className="bw-home">
      <section className="bw-hero">
        <div className="bw-hero-inner">
          <div className="bw-hero-text">
            <span className="eyebrow">Spring Harvest · Vol. 26</span>
            <h1>Coffee, roasted<br />the morning <em>it ships.</em></h1>
            <p className="bw-hero-lead">Single-origin lots, capsule pods, espresso machines, sourced direct and roasted in small batches in NYC.</p>
            <div className="bw-hero-cta">
              <button className="bw-btn bw-btn--primary bw-btn--large" onClick={() => onNav('shop')}>Shop All <Icon name="arrowSm" className="icon icon--sm" /></button>
            </div>
          </div>
          <div className="bw-hero-img">
            <img src="/images/site/hero.png" alt="Brewed hero" style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center', display: 'block' }} />
            <div className="bw-hero-meta">№ 26 · Spring · Ethiopia</div>
          </div>
        </div>
      </section>

      <section className="bw-strip">
        <div className="bw-strip-inner">
          <div className="bw-strip-item"><Icon name="leaf" className="icon icon--sm" />Roasted to order</div>
          <div className="bw-strip-item"><Icon name="truck" className="icon icon--sm" />Free US shipping over $40</div>
          <div className="bw-strip-item"><Icon name="clock" className="icon icon--sm" />Ships within 48 hours</div>
          <div className="bw-strip-item"><Icon name="check" className="icon icon--sm" />Direct trade, every lot</div>
        </div>
      </section>

      <section className="bw-section">
        <div className="bw-section-inner">
          <div className="bw-section-head">
            <div>
              <span className="eyebrow">Featured · This Week</span>
              <h2 className="bw-section-title">Pour something <em>good.</em></h2>
            </div>
            <a className="bw-btn bw-btn--ghost" onClick={() => onNav('shop')}>All Products <Icon name="arrowSm" className="icon icon--sm" /></a>
          </div>
          <div className="bw-grid">
            {featured.map(p => (
              <ProductCard key={p.id} p={p} onOpen={onOpen} onAdd={addToCart} wished={wishlist.includes(p.id)} onWish={toggleWish} />
            ))}
          </div>
        </div>
      </section>

      <section className="bw-section">
        <div className="bw-section-inner">
          <div className="bw-section-head">
            <div>
              <span className="eyebrow">Categories</span>
              <h2 className="bw-section-title">Shop by <em>shelf.</em></h2>
            </div>
          </div>
          <div className="bw-cats">
            {data.categories.map(c => (
              <div key={c.id} className="bw-cat" onClick={() => onNav('shop', { type: c.id })}>
                {CATEGORY_IMAGES[c.id]
                  ? <img src={CATEGORY_IMAGES[c.id]} alt={c.name} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', display: 'block', zIndex: 0 }} />
                  : <div className="bw-cat-stripe"></div>
                }
                <div className="bw-cat-overlay"></div>
                <div className="bw-cat-label">
                  <span className="bw-cat-name">{c.name}</span>
                  <span className="bw-cat-count">{c.count} items · {c.sub}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bw-quiz-cta">
        <div className="bw-quiz-cta-card">
          <span className="eyebrow">Not sure where to start?</span>
          <h2 className="bw-section-title">Find your <em>perfect cup.</em></h2>
          <p>Answer a few quick questions about how you brew and what you like, we'll match you to three roasts in under a minute.</p>
          <button className="bw-btn bw-btn--primary bw-btn--large" onClick={() => onOpenQuiz && onOpenQuiz()}>
            Take the quiz <Icon name="arrowSm" className="icon icon--sm" />
          </button>
        </div>
      </section>

      <section className="bw-editorial">
        <div className="bw-editorial-inner">
          <div className="bw-editorial-text">
            <span className="eyebrow">Sourcing · Direct Trade</span>
            <h2>Twelve farms.<br /><em>One handshake at a time.</em></h2>
            <p>We buy from the same producers, season after season — paying 30 to 60 percent above the C-market and visiting every harvest.</p>
            <div><a className="bw-btn bw-btn--outline" onClick={() => onNav('blog')}>Read the journal <Icon name="arrowSm" className="icon icon--sm" /></a></div>
          </div>
          <div className="bw-editorial-img">
            <img src="/images/site/coffee-farm.png" alt="Coffee farm" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
          </div>
        </div>
      </section>
    </div>
  );
};

// =================== PLP ===================
export const PLPPage = ({ data, initialType, onOpen, addToCart, wishlist, toggleWish }) => {
  const [filters, setFilters] = useState({
    type: initialType ? [initialType] : [],
    roast: [],
    intensity: [1, 12],
    minRating: 0,
    decaf: false,
    inStock: false,
    price: 800,
  });
  const [sort, setSort] = useState('Featured');
  const [sortOpen, setSortOpen] = useState(false);

  useEffect(() => {
    setFilters(f => ({ ...f, type: initialType ? [initialType] : [] }));
  }, [initialType]);

  const toggle = (k, v) => setFilters(f => ({ ...f, [k]: f[k].includes(v) ? f[k].filter(x => x !== v) : [...f[k], v] }));

  const filtered = useMemo(() => {
    let list = data.products.filter(p =>
      (filters.type.length === 0 || filters.type.includes(p.type)) &&
      (filters.roast.length === 0 || (p.roast && filters.roast.includes(p.roast))) &&
      (!p.intensity || (p.intensity >= filters.intensity[0] && p.intensity <= filters.intensity[1])) &&
      p.rating >= filters.minRating &&
      (!filters.decaf || p.decaf) &&
      (!filters.inStock || p.stock) &&
      p.price <= filters.price
    );
    if (sort === 'Price: Low') list = [...list].sort((a, b) => a.price - b.price);
    if (sort === 'Price: High') list = [...list].sort((a, b) => b.price - a.price);
    if (sort === 'Top Rated') list = [...list].sort((a, b) => b.rating - a.rating);
    if (sort === 'Intensity: Low') list = [...list].sort((a, b) => (a.intensity || 99) - (b.intensity || 99));
    if (sort === 'Intensity: High') list = [...list].sort((a, b) => (b.intensity || 0) - (a.intensity || 0));
    return list;
  }, [data, filters, sort]);

  const showIntensity = filters.type.length === 0 || filters.type.some(t => t === 'beans' || t === 'pods');
  const showRoast = filters.type.length === 0 || filters.type.includes('beans');

  return (
    <>
      <div className="bw-plp-header">
        <div className="bw-plp-header-inner">
          <div>
            <span className="eyebrow">All Products · {filtered.length} of {data.products.length} items</span>
            <h1 style={{ marginTop: '8px' }}>The full <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>shelf.</em></h1>
            <p>Beans, pods, machines, and gear — sourced direct, shipped within 48 hours.</p>
          </div>
          <div className="bw-plp-meta">
            <span><Icon name="grid" className="icon icon--sm" style={{ verticalAlign: 'middle', marginRight: 6 }} />Grid</span>
            <div className="bw-plp-sort" onClick={() => setSortOpen(!sortOpen)} style={{ position: 'relative' }}>
              Sort: {sort} <Icon name="chevDown" className="icon icon--sm" />
              {sortOpen && (
                <div style={{ position: 'absolute', top: '100%', right: 0, background: 'var(--paper)', color: 'var(--ink)', border: '1px solid var(--line)', marginTop: 4, minWidth: 180, zIndex: 5, borderRadius: 'var(--radius)', overflow: 'hidden', boxShadow: 'var(--shadow-warm)' }}>
                  {['Featured', 'Price: Low', 'Price: High', 'Top Rated', 'Intensity: Low', 'Intensity: High'].map(s => (
                    <div key={s} style={{ padding: '10px 14px', cursor: 'pointer', fontSize: 11, letterSpacing: '0.12em' }} onClick={(e) => { e.stopPropagation(); setSort(s); setSortOpen(false); }}>{s}</div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="bw-plp">
        <div className="bw-plp-inner">
        <aside className="bw-filters">
          <div className="bw-filter-group">
            <h3>Product Type</h3>
            {data.categories.map(c => (
              <label key={c.id} className="bw-filter-opt">
                <input type="checkbox" checked={filters.type.includes(c.id)} onChange={() => toggle('type', c.id)} />
                <span>{c.name}</span>
                <span className="bw-filter-opt-count">{c.count}</span>
              </label>
            ))}
          </div>
          {showIntensity && (
            <div className="bw-filter-group">
              <h3>Intensity · {filters.intensity[0]} – {filters.intensity[1]}</h3>
              <div className="bw-int-range">
                <span>1</span>
                <input type="range" min="1" max="12" value={filters.intensity[0]} onChange={(e) => setFilters(f => ({ ...f, intensity: [Math.min(+e.target.value, f.intensity[1]), f.intensity[1]] }))} />
                <span>{filters.intensity[0]}</span>
              </div>
              <div className="bw-int-range" style={{ marginTop: 4 }}>
                <span>{filters.intensity[1]}</span>
                <input type="range" min="1" max="12" value={filters.intensity[1]} onChange={(e) => setFilters(f => ({ ...f, intensity: [f.intensity[0], Math.max(+e.target.value, f.intensity[0])] }))} />
                <span>12</span>
              </div>
            </div>
          )}
          {showRoast && (
            <div className="bw-filter-group">
              <h3>Roast Level</h3>
              {['Light', 'Medium', 'Dark'].map(r => (
                <label key={r} className="bw-filter-opt">
                  <input type="checkbox" checked={filters.roast.includes(r)} onChange={() => toggle('roast', r)} />
                  <span>{r}</span>
                </label>
              ))}
            </div>
          )}
          <div className="bw-filter-group">
            <h3>Customer Rating</h3>
            {[4.5, 4.0, 3.5].map(r => (
              <label key={r} className="bw-filter-opt">
                <input type="radio" name="rating" checked={filters.minRating === r} onChange={() => setFilters(f => ({ ...f, minRating: r }))} />
                <span><span style={{ color: 'var(--accent)' }}>★</span> {r} & up</span>
              </label>
            ))}
            <label className="bw-filter-opt">
              <input type="radio" name="rating" checked={filters.minRating === 0} onChange={() => setFilters(f => ({ ...f, minRating: 0 }))} />
              <span>All ratings</span>
            </label>
          </div>
          <div className="bw-filter-group">
            <h3>Price · up to ${filters.price}</h3>
            <input type="range" min="10" max="800" step="10" value={filters.price} onChange={(e) => setFilters(f => ({ ...f, price: +e.target.value }))} style={{ width: '100%' }} />
          </div>
          <div className="bw-filter-group">
            <h3>Other</h3>
            <label className="bw-filter-opt">
              <input type="checkbox" checked={filters.decaf} onChange={() => setFilters(f => ({ ...f, decaf: !f.decaf }))} />
              <span>Decaf only</span>
            </label>
            <label className="bw-filter-opt">
              <input type="checkbox" checked={filters.inStock} onChange={() => setFilters(f => ({ ...f, inStock: !f.inStock }))} />
              <span>In stock</span>
            </label>
          </div>
          <button className="bw-btn bw-btn--ghost bw-btn--small bw-btn--block" onClick={() => setFilters({ type: [], roast: [], intensity: [1, 12], minRating: 0, decaf: false, inStock: false, price: 800 })}>Clear all</button>
        </aside>
        <div className="bw-grid bw-grid--3">
          {filtered.map(p => (
            <ProductCard key={p.id} p={p} onOpen={onOpen} onAdd={addToCart} wished={wishlist.includes(p.id)} onWish={toggleWish} />
          ))}
          {filtered.length === 0 && (
            <div style={{ gridColumn: '1 / -1', padding: 80, textAlign: 'center', color: 'rgba(239,232,217,0.5)' }}>
              <p style={{ fontFamily: 'var(--serif)', fontSize: 28, marginBottom: 8, color: 'var(--cream-pale)' }}>No matches.</p>
              <p>Try clearing some filters.</p>
            </div>
          )}
        </div>
        </div>
      </div>
    </>
  );
};

// =================== PDP ===================
export const PDPPage = ({ p, data, onOpen, addToCart, wishlist, toggleWish, onNav }) => {
  const [size, setSize] = useState('250g');
  const [grind, setGrind] = useState('Whole Bean');
  const [pack, setPack] = useState(p.pack || 10);
  const [color, setColor] = useState(p.colors ? p.colors[0].name : null);
  const [qty, setQty] = useState(1);
  const [thumb, setThumb] = useState(0);
  const isCoffee = p.type === 'beans';
  const isMachine = p.type === 'machines';
  const related = data.products.filter(x => x.type === p.type && x.id !== p.id).slice(0, 4);

  // Reviews are looked up per product (falling back to a per-category pool)
  // instead of one hardcoded array shared by every product page. The
  // rating breakdown bars below are derived from that same set rather than
  // a fixed 78/16/4/1/1 split that never matched what was actually shown.
  const productReviews = data.getReviewsForProduct(p);
  const reviewCounts = [5, 4, 3, 2, 1].map(n => productReviews.filter(r => Math.round(r.rating) === n).length);
  const reviewTotal = productReviews.length || 1;
  const unitPrice = p.type === 'pods'
    ? +(p.price * (PACK_MULTIPLIER[pack] || 1)).toFixed(2)
    : isCoffee
      ? +((p.price * (SIZE_MULTIPLIER[size] || 1)) + (GRIND_SURCHARGE[grind] || 0)).toFixed(2)
      : p.price;

  return (
    <>
      <div className="bw-pdp">
        <div className="bw-pdp-inner">
        <div className="bw-pdp-gallery">
          <div className="bw-pdp-thumbs">
            {[0, 1, 2, 3].map(i => (
              <div key={i} className={`bw-pdp-thumb ${thumb === i ? 'is-active' : ''}`} onClick={() => setThumb(i)}>
                <div className="bw-pdp-thumb-stripe"></div>
              </div>
            ))}
          </div>
          <div className="bw-pdp-main">
            {p.image
              ? <img src={p.image} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
              : <div className="bw-pdp-main-stripe"><div className="bw-card-img-label">{p.name}{color ? ' · ' + color : ''} · View {thumb + 1}</div></div>
            }
          </div>
        </div>
        <div className="bw-pdp-info">
          <div className="bw-pdp-bread">
            <span onClick={() => onNav('home')} style={{ cursor: 'pointer' }}>Home</span>
            <span onClick={() => onNav('shop')} style={{ cursor: 'pointer' }}>Shop</span>
            <span>{p.name}</span>
          </div>
          <div className="bw-pdp-origin">{p.origin}</div>
          <h1 className="bw-pdp-title">{p.name}</h1>
          <div className="bw-pdp-price">
            <span className="bw-pdp-price-now">${(p.type === 'pods' || isCoffee) ? unitPrice.toFixed(2) : p.price}</span>
            {p.was && <span className="bw-pdp-price-was">${p.was}</span>}
          </div>
          <div className="bw-pdp-rating">
            <Stars n={p.rating} />
            <span>{p.rating.toFixed(1)}</span>
            <span style={{ color: 'rgba(239,232,217,0.3)' }}>·</span>
            <span>{p.reviews} reviews</span>
            <span style={{ color: 'rgba(239,232,217,0.3)' }}>·</span>
            {p.stock ? <span className="bw-stock"><span className="bw-stock-dot"></span>In stock</span> : <span className="mono" style={{ color: 'rgba(239,232,217,0.4)' }}>Sold out</span>}
          </div>
          <p className="bw-pdp-desc">{p.notes}{isCoffee && p.producer && `. From ${p.producer}${p.altitude ? ', grown at ' + p.altitude : ''}, ${(p.process || '').toLowerCase()}-processed.`}</p>

          {p.intensity && (
            <div style={{ marginBottom: 24 }}>
              <Intensity value={p.intensity} />
            </div>
          )}

          {p.tasting && (
            <div className="bw-pdp-tasting">
              {Object.entries(p.tasting).map(([k, v]) => (
                <div key={k} className="bw-tasting-item">
                  <span className="bw-tasting-label">{k}</span>
                  <span className="bw-tasting-val">{v}</span>
                </div>
              ))}
            </div>
          )}

          {isMachine && p.colors && (
            <div className="bw-variant-row">
              <div className="bw-variant-label"><span>Color</span><strong>{color}</strong></div>
              <ColorSwatches colors={p.colors} selected={color} onSelect={setColor} large />
            </div>
          )}

          {isCoffee && (
            <div className="bw-variants">
              <div className="bw-variant-row">
                <div className="bw-variant-label"><span>Size</span><strong>{size}</strong></div>
                <div className="bw-variant-opts">
                  {['250g', '500g', '1kg'].map(s => (
                    <button key={s} className={`bw-variant-opt ${size === s ? 'is-active' : ''}`} onClick={() => setSize(s)}>{s}</button>
                  ))}
                </div>
              </div>
              <div className="bw-variant-row">
                <div className="bw-variant-label"><span>Grind</span><strong>{grind}</strong></div>
                <div className="bw-variant-opts">
                  {['Whole Bean', 'Espresso', 'Filter', 'French Press'].map(g => (
                    <button key={g} className={`bw-variant-opt ${grind === g ? 'is-active' : ''}`} onClick={() => setGrind(g)}>{g}</button>
                  ))}
                </div>
              </div>
            </div>
          )}

          {p.type === 'pods' && (
            <div className="bw-variants">
              <div className="bw-variant-row">
                <div className="bw-variant-label"><span>Pack</span><strong>{pack} pods</strong></div>
                <div className="bw-variant-opts">
                  {[10, 30, 50].map(s => (
                    <button key={s} className={`bw-variant-opt ${pack === s ? 'is-active' : ''}`} onClick={() => setPack(s)}>{s}</button>
                  ))}
                </div>
              </div>
            </div>
          )}

          <div className="bw-pdp-actions">
            <div className="bw-qty">
              <button onClick={() => setQty(Math.max(1, qty - 1))}>−</button>
              <input value={qty} onChange={(e) => setQty(Math.max(1, +e.target.value || 1))} />
              <button onClick={() => setQty(qty + 1)}>+</button>
            </div>
            <button className="bw-btn bw-btn--primary bw-btn--block" onClick={() => addToCart({ ...p, price: unitPrice, size, grind, color, ...(p.type === 'pods' ? { pack } : {}) }, qty)}>
              Add to Cart · ${(unitPrice * qty).toFixed(2)}
            </button>
            <button className={`bw-card-wish ${wishlist.includes(p.id) ? 'is-active' : ''}`} onClick={() => toggleWish(p.id)} style={{ position: 'static', width: 48, height: 48, border: '1px solid var(--line)', background: 'var(--paper)', color: 'var(--ink)' }}>
              <Icon name={wishlist.includes(p.id) ? 'heartFill' : 'heart'} className="icon icon--sm" />
            </button>
          </div>

          <div className="bw-pdp-feat">
            <div className="bw-feat"><span className="bw-feat-label">{isCoffee ? 'Roast Date' : 'Ships'}</span><span className="bw-feat-val">{isCoffee ? 'Apr 28, 2026' : 'In 48 hours'}</span></div>
            <div className="bw-feat"><span className="bw-feat-label">Warranty</span><span className="bw-feat-val">{isMachine ? '2-year' : '14-day promise'}</span></div>
            <div className="bw-feat"><span className="bw-feat-label">Returns</span><span className="bw-feat-val">14-day promise</span></div>
          </div>
        </div>
        </div>
      </div>

      <section className="bw-reviews">
        <div className="bw-reviews-inner">
        <div className="bw-section-head">
          <h2 className="bw-section-title">What people are <em>saying.</em></h2>
          <button className="bw-btn bw-btn--ghost">Write a review</button>
        </div>
        <div className="bw-reviews-head">
          <div className="bw-reviews-summary">
            <Stars n={p.rating} />
            <span className="bw-reviews-score">{p.rating.toFixed(1)}</span>
            <span style={{ fontSize: 13, color: 'rgba(239,232,217,0.55)' }}>Based on {p.reviews} reviews</span>
          </div>
          <div className="bw-reviews-bars">
            {[5, 4, 3, 2, 1].map((n, idx) => {
              const count = reviewCounts[idx];
              const pct = Math.round((count / reviewTotal) * 100);
              return (
                <div key={n} className="bw-reviews-bar">
                  <span>{n}★</span>
                  <div className="bw-bar"><div className="bw-bar-fill" style={{ width: `${pct}%` }}></div></div>
                  <span>{pct}%</span>
                </div>
              );
            })}
          </div>
        </div>
        {productReviews.map((r, i) => (
          <div key={i} className="bw-review">
            <div className="bw-review-meta">
              <span className="bw-review-author">{r.author}</span>
              <span className="bw-review-date">{r.date}</span>
              <span className="bw-review-verified"><Icon name="check" className="icon icon--sm" />Verified buyer</span>
            </div>
            <div className="bw-review-body">
              <Stars n={r.rating} className="bw-stars bw-review-stars" />
              <h4>{r.title}</h4>
              <p>{r.body}</p>
            </div>
          </div>
        ))}
        </div>
      </section>

      <section className="bw-section">
        <div className="bw-section-inner">
          <div className="bw-section-head">
            <h2 className="bw-section-title">You might <em>also like.</em></h2>
          </div>
          <div className="bw-grid">
            {related.map(p2 => (
              <ProductCard key={p2.id} p={p2} onOpen={onOpen} onAdd={addToCart} wished={wishlist.includes(p2.id)} onWish={toggleWish} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

// =================== BLOG ===================
export const BlogPage = ({ data }) => {
  const [tag, setTag] = useState('All');
  const tags = ['All', ...Array.from(new Set(data.articles.map(a => a.tag)))];
  const filtered = tag === 'All' ? data.articles : data.articles.filter(a => a.tag === tag);
  const [feature, ...rest] = filtered;
  return (
    <>
      <section className="bw-blog-hero">
        <div className="bw-blog-hero-inner">
          <div>
            <span className="eyebrow">The Brewed Journal</span>
            <h1 style={{ marginTop: 16 }}>Recipes, field notes,<br />& <em>opinions about coffee.</em></h1>
          </div>
          <p>Brewing guides, recipes from our cafe, dispatches from origin trips, and the occasional roast-day diary. Updated every other Tuesday.</p>
        </div>
      </section>
      <div className="bw-blog-tags">
        <div className="bw-blog-tags-inner">
          {tags.map(t => (
            <button key={t} className={`bw-blog-tag ${tag === t ? 'is-active' : ''}`} onClick={() => setTag(t)}>{t}</button>
          ))}
        </div>
      </div>
      <div className="bw-blog-grid">
        <div className="bw-blog-grid-inner">
          {feature && (
            <div className="bw-article bw-article--feature">
              <div className="bw-article-img">
                {feature.image
                  ? <img src={feature.image} alt={feature.title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                  : <div className="bw-article-img-stripe"><div className="bw-card-img-label">Feature · {feature.title}</div></div>
                }
              </div>
              <div>
                <span className="bw-article-kind">{feature.kind} · Featured</span>
                <h2 className="bw-article-title" style={{ marginTop: 8 }}>{feature.title}</h2>
                <p className="bw-article-excerpt" style={{ marginTop: 12 }}>{feature.excerpt}</p>
                <div className="bw-article-meta" style={{ marginTop: 16 }}>
                  <span>{feature.author}</span><span>{feature.date}</span><span>{feature.read}</span>
                </div>
                <button className="bw-btn bw-btn--outline" style={{ marginTop: 20 }}>Read article <Icon name="arrowSm" className="icon icon--sm" /></button>
              </div>
            </div>
          )}
          {rest.map(a => (
            <div key={a.id} className="bw-article">
              <div className="bw-article-img">
                {a.image
                  ? <img src={a.image} alt={a.title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                  : <div className="bw-article-img-stripe"><div className="bw-card-img-label">{a.kind} · {a.tag}</div></div>
                }
              </div>
              <span className="bw-article-kind">{a.kind} · {a.tag}</span>
              <h3 className="bw-article-title">{a.title}</h3>
              <p className="bw-article-excerpt">{a.excerpt}</p>
              <div className="bw-article-meta"><span>{a.author}</span><span>{a.date}</span><span>{a.read}</span></div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

// =================== CONTACT ===================
export const ContactPage = ({ onNav }) => (
  <>
    <section className="bw-contact-hero">
      <div className="bw-contact-hero-inner">
        <span className="eyebrow">Get in touch</span>
        <h1 style={{ marginTop: 16 }}>Come visit, or just <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>say hi.</em></h1>
        <p style={{ color: 'rgba(239,232,217,0.6)', maxWidth: 540, margin: '12px auto 0', fontSize: 16 }}>The roastery doors are open Tuesday through Sunday. Pull up a stool — the espresso's on.</p>
      </div>
    </section>
    <section className="bw-contact-grid">
      <div className="bw-contact-grid-inner">
        <div className="bw-contact-card">
          <h3><Icon name="pin" className="icon icon--sm" style={{ verticalAlign: 'middle', marginRight: 6 }} />Visit</h3>
          <div className="bw-contact-card-body">67 East 7th Street<br />New York, NY 10003</div>
          <div className="bw-contact-card-meta">6 train · Astor Place</div>
        </div>
        <div className="bw-contact-card">
          <h3><Icon name="clock" className="icon icon--sm" style={{ verticalAlign: 'middle', marginRight: 6 }} />Hours</h3>
          <div className="bw-contact-card-body">Tue – Fri · 7am – 4pm<br />Sat – Sun · 8am – 5pm</div>
          <div className="bw-contact-card-meta">Closed Mondays · Roasting day</div>
        </div>
        <div className="bw-contact-card">
          <h3><Icon name="mail" className="icon icon--sm" style={{ verticalAlign: 'middle', marginRight: 6 }} />Reach us</h3>
          <div className="bw-contact-card-body">hello@brewed.coffee<br />+1 (718) 555-0142</div>
          <div className="bw-contact-card-meta">Replies within 24 hours</div>
        </div>
      </div>
    </section>
    <section className="bw-section">
      <div className="bw-section-inner" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'center' }}>
        <div>
          <span className="eyebrow">Send a message</span>
          <h2 className="bw-section-title" style={{ marginTop: 8 }}>We read every <em>email.</em></h2>
          <p style={{ color: 'rgba(239,232,217,0.6)', marginTop: 12, maxWidth: 420 }}>Whether it's a wholesale inquiry, a brewing question, or a recipe you want us to try — we'd love to hear from you.</p>
          <form style={{ marginTop: 24, display: 'grid', gap: 12 }} onSubmit={(e) => e.preventDefault()}>
            <div className="bw-form-row">
              <div className="bw-field"><label>Name</label><input /></div>
              <div className="bw-field"><label>Email</label><input /></div>
            </div>
            <div className="bw-field"><label>Subject</label><input /></div>
            <div className="bw-field"><label>Message</label><textarea rows="5" /></div>
            <button className="bw-btn bw-btn--primary" style={{ justifySelf: 'start' }}>Send message <Icon name="arrowSm" className="icon icon--sm" /></button>
          </form>
        </div>
        <div style={{ aspectRatio: '4/5', background: 'var(--cream-deep)', position: 'relative', borderRadius: 'var(--radius)', overflow: 'hidden', boxShadow: 'var(--shadow-warm)' }}>
          <img src="/images/contact/map.png" alt="Map" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        </div>
      </div>
    </section>
    {/* deliberate light island, like the homepage editorial band — everything
        inside gets explicit dark-on-light colors rather than inheriting the
        page's cream-pale-on-roast defaults */}
    <section className="bw-contact-cta">
      <div className="bw-contact-cta-inner">
        <span className="eyebrow">Common questions</span>
        <h2 className="bw-section-title">Looking for an <em>answer?</em></h2>
        <p>Most questions about shipping, returns, brewing, and machines live on the FAQ page.</p>
        <button className="bw-btn bw-btn--primary bw-btn--large" onClick={() => onNav('faq')}>Browse FAQ <Icon name="arrowSm" className="icon icon--sm" /></button>
      </div>
    </section>
  </>
);

// =================== FAQ ===================
export const FAQPage = ({ data, onNav }) => {
  const [openFaq, setOpenFaq] = useState(0);
  const [qry, setQry] = useState('');
  const filtered = qry ? data.faqs.filter(f => f.q.toLowerCase().includes(qry.toLowerCase()) || f.a.toLowerCase().includes(qry.toLowerCase())) : data.faqs;
  return (
    <>
      <section className="bw-contact-hero">
        <div className="bw-contact-hero-inner">
          <span className="eyebrow">Help center</span>
          <h1 style={{ marginTop: 16 }}>Questions, <em style={{ fontStyle: 'italic', color: 'var(--accent-soft)' }}>answered.</em></h1>
          <p style={{ color: 'rgba(239,232,217,0.6)', maxWidth: 540, margin: '12px auto 0', fontSize: 16 }}>Shipping, brewing, machines — all in one place.</p>
          <div style={{ maxWidth: 480, margin: '24px auto 0', display: 'flex', gap: 8, alignItems: 'center', padding: '10px 16px', border: '1px solid var(--line)', borderRadius: 'var(--radius)', background: 'var(--paper)' }}>
            <Icon name="search" className="icon icon--sm" style={{ color: 'var(--ink-muted)' }} />
            <input style={{ flex: 1, border: 'none', outline: 'none', background: 'transparent', fontSize: 14, color: 'var(--ink)' }} placeholder="Search the FAQ" value={qry} onChange={(e) => setQry(e.target.value)} />
          </div>
        </div>
      </section>
      <section className="bw-faq">
        <div className="bw-faq-inner">
          {filtered.length === 0 && <p style={{ textAlign: 'center', color: 'rgba(239,232,217,0.5)', padding: 40 }}>No matches for "{qry}"</p>}
          <div className="bw-faq-list">
            {filtered.map((f, i) => (
              <div key={i} className={`bw-faq-item ${openFaq === i ? 'is-open' : ''}`}>
                <button className="bw-faq-q" onClick={() => setOpenFaq(openFaq === i ? -1 : i)}>
                  <span className="bw-faq-q-index">{String(i + 1).padStart(2, '0')}</span>
                  <span className="bw-faq-q-text">{f.q}</span>
                  <span className="bw-faq-icon">+</span>
                </button>
                <div className="bw-faq-a">{f.a}</div>
              </div>
            ))}
          </div>
          <div className="bw-faq-cta">
            <div className="bw-faq-cta-text">
              <h3>Still have a question?</h3>
              <p>Our team replies within 24 hours.</p>
            </div>
            <button className="bw-btn bw-btn--primary" onClick={() => onNav('contact')}>Contact us <Icon name="arrowSm" className="icon icon--sm" /></button>
          </div>
        </div>
      </section>
    </>
  );
};